import { IconButton, InputAdornment, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import SearchIcon from '@mui/icons-material/Search';
import { CustomTextField } from '../../layout/styledcomponents/CustomTextField';
import { selectReportAPIRefSliceData } from '../../app/Slices/ReportAPIRefSlice';
import ReactGA from 'react-ga4';
import { trackEvent } from '../../app/Analytics';
import UserRole from '../../shared/AuthRoles';

const defaultSearchValueParser = (searchText: any) =>
    searchText.split(' ').filter((word: any) => word !== '');

export default function SearchFilter(props: any) {
    const {
        quickFilterParser = defaultSearchValueParser,
        debounceMs = 500,
        ...other
    } = props;
    const loggedInUser = UserRole();
    const reportExportAPI: any = useSelector(selectReportAPIRefSliceData);
    const [searchValue, setSearchValue] = React.useState('');

    useEffect(() => {
        const savedSearch = sessionStorage.getItem('searchValue') || '';
        setSearchValue(savedSearch);

        if (savedSearch && typeof reportExportAPI?.search === 'function') {
            reportExportAPI.search(quickFilterParser(savedSearch));
        }
    }, [reportExportAPI, quickFilterParser]);

    const handleSearchValueChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        const newSearchValue = event.target.value;
        sessionStorage.setItem('searchValue', newSearchValue);
        setSearchValue(newSearchValue);
        reportExportAPI?.search(quickFilterParser(newSearchValue));

        trackEvent(
            'Reservations',
            'Search Reservation',
            `Search Reservation - (${loggedInUser?.role})`,
        );
    };

    const isMobile = useMediaQuery('(max-width: 770px)');

    return (
        <CustomTextField
            fullWidth={isMobile}
            color='dark'
            placeholder='Search...'
            value={searchValue}
            onChange={handleSearchValueChange}
            InputProps={{
                style: {
                    minHeight: '30px',
                    maxHeight: '38px',
                },
                endAdornment: (
                    <InputAdornment position='end'>
                        <IconButton disableRipple>
                            <SearchIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
}
